export default __webpack_public_path__ + "static/media/app_dev_vo.7bbef82d.jpeg";